module.exports = __webpack_public_path__ + "img/pic_martin.add6c9c9.png";